import React from 'react'
import {TooltipProps} from './types'
import resolveProps from '../../utils/resolveProps'


const config = {
  types: [
    {
      title: 'top',
      isDefault: true
    },
    'right',
    'bottom',
    'left'
  ],
  modifiers: [],
  states: []
}

export default function Tooltip(props: TooltipProps) {
  const { isVisible, children, top, left, right, bottom, ...rest } = props

  return (
    <div
      {...rest}
      className={resolveProps(props, config, 'Tooltip')}
      style={{ display: isVisible ? 'inline-flex' : 'none' }}
    >
      <p className="mdn-Text mdn-Text--body mdn-Text--inverse">{children}</p>
    </div>
  )
}
